// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { getFromStorage } from "../lib/storage";

const ProtectedRoute = ({ children }) => {
    const token = getFromStorage("lmsCCToken");
    if (!token) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default ProtectedRoute;
